import { getSessionUserInformation } from "app/utils/utility.service";
import { getRentOwnedEstateRecords } from "app/utils/utility.service";
import { getSessionUserSettings } from "app/utils/utility.service";
import { FormatAmount } from "app/utils/utility.service";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Panel } from "primereact/panel";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { insertLogs } from "../../../homepurchase.service";
import {
    changeLeftCalculations,
    changeMonthlyMortgageExpenses,
    getAnnualExpenseCalculation,
    getExpenses,
    getLeftCalculations,
    getMortgageStructureExpensesCalculations,
} from "../../../HomePurchaseStep3Slice";
import AnnualExpense from "./AnnualExpense/AnnualExpense";
import MonthlyExpense from "./MonthlyExpense/MonthlyExpense";
import RentalEstateGraphModal from "./RentalEstateGraphModal";
import { FIRST_LOAN_RATE } from "app/utils/Constants";
import { useMediaQuery } from "react-responsive";
import AddPropertyInformation from "./PropertyInformation/AddPropertyInformation";
import { NumericFormat } from "react-number-format";
import { getSubscription } from "app/views/subscription/subscription.service";
import SubscriptionDialog from "app/components/partials/SubscriptionDialog";


const OwnHouse = ({
    handleLeftCalculations,
    handleExpensesSave,
    handleOwnHouseSave,
    mortgageStructureModal,
    handleMortgageStructureModal,
    taxBreakModal,
    handleTaxBreakModal,
    handleReportChangeSave
}) => {
    const [monthlyExpenseModal, setMonthlyExpenseModal] = useState(false);
    const [annualExpenseModal, setAnnualExpenseModal] = useState(false);
    const [rentalEstateModal, setRentalEstateModal] = useState(false);
    const [propertyInformationModal, setPropertyInformationModal] = useState(false);  
    const [graphRecord, setGraphRecord] = useState(null);
    const [addDisable, setAddDisable] = useState(false);
    const expensesRecord = useSelector(getExpenses);
    const userSettings = getSessionUserSettings();
    const userRecord = getSessionUserInformation();
    const dispatch = useDispatch();
    let sessionValues = getSessionUserInformation();
    const leftContentValues = useSelector(getLeftCalculations);
    const mortgageMonthlyExpenses = useSelector(
        getMortgageStructureExpensesCalculations
    );
    const annualExpenseValues = useSelector(getAnnualExpenseCalculation);
    const [featureModal, setFeatureModal] = useState(false);
    const [isDialog, setIsDialog] = useState(false);
    //const [searchParams] = useSearchParams();
   // const clientId = searchParams.get("clientid");
    const {state} = useLocation();
	const clientId  = state?.clientid; 
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1224px)",
    });
    const isTablet = useMediaQuery({
        query: "(min-width: 768px) and (max-width: 1024px)",
    });
    const prefix = "$ ";

    useEffect( () => {
       fetchSubscription();
    }, []);
    const fetchSubscription = async () => {
       let sub = await getSubscription(sessionValues.id);
       let currentPlan = (sub?.subscription_plan?.monthly_price === "0.00" && sub?.subscription_plan?.annual_price === "0.00") && sub?.subscription_plan?.name?.trim()?.toLowerCase() !== "sponsored";
         if(currentPlan) {
            setAddDisable(true);
         } else {
            setAddDisable(false);
         }

    }
    const handleMonthlyExpenseModal = () => {
        if (!monthlyExpenseModal) {
            const payload = {
                description: "View Monthly Expenses",
            };
            insertLogs(payload);
        }
        setMonthlyExpenseModal(!monthlyExpenseModal);
    };

    const handleAnnualExpenseModal = () => {
        if (!annualExpenseModal) {
            const payload = {
                description: "View Annual Expenses",
            };
            insertLogs(payload);
        }
        setAnnualExpenseModal(!annualExpenseModal);
    };

    const handleSubscriptionModal = () => {
     
      setFeatureModal(!featureModal);
      setIsDialog(true);
    };
    const renderSubscriptionModal = () => (
      <SubscriptionDialog featureModal={featureModal} 
      handleSubscriptionModal={handleSubscriptionModal}
      isDialog={isDialog}

      />
    );

    const handlePropertyInformationModal = async () => {
        if (!propertyInformationModal) {
            if(clientId && clientId !== "null") {
               await handleReportChangeSave(clientId, false)
            } else {
               await handleReportChangeSave(null, false)

            }
            const payload = {
                description: "Add Property Information",
            };
            insertLogs(payload);
        }
        if(addDisable) {
            setIsDialog(true);
            setFeatureModal(!featureModal);
        } else {
            if(leftContentValues?.purchasePrice && leftContentValues.rent)
            setPropertyInformationModal(!propertyInformationModal);
        }
    };

    const handleRentalEstateGraphModal = () => {
        setGraphRecord(null);
        if (!rentalEstateModal) {
            const fetchedRecord = getRentOwnedEstateRecords(
                userRecord,
                expensesRecord,
                userSettings
            );
            setGraphRecord(fetchedRecord);
            // const payload = {
            //     description: "View Rental / Owned Estate Graph",
            // };
            // insertLogs(payload);
        }
        setRentalEstateModal(!rentalEstateModal);
    };

    // const handleMortgageStructureModal = () => {
    //     setMortgageStructureModal(!mortgageStructureModal);
    // };

    // const renderMortgageStructureModal = () => (
    //     <MortgageStructure
    //         mortgageStructureModal={mortgageStructureModal}
    //         handleMortgageStructureModal={handleMortgageStructureModal}
    //         handleExpensesSave={handleExpensesSave}
    //     />
    // );

    const renderMonthlyExpenseModal = () => (
        <MonthlyExpense
            monthlyExpenseModal={monthlyExpenseModal}
            handleMonthlyExpenseModal={handleMonthlyExpenseModal}
            handleExpensesSave={handleExpensesSave}
            mortgageStructureModal={mortgageStructureModal}
            handleMortgageStructureModal={handleMortgageStructureModal}
            taxBreakModal={taxBreakModal}
            handleTaxBreakModal={handleTaxBreakModal}
        />
    );

    const renderAnnualExpenseModal = () => (
        <AnnualExpense
            annualExpenseModal={annualExpenseModal}
            handleAnnualExpenseModal={handleAnnualExpenseModal}
            handleExpensesSave={handleExpensesSave}
        />
    );

    const renderPropertyInformationModal = () => (
        <AddPropertyInformation
        mortgageMonthlyExpenses={mortgageMonthlyExpenses}
        propertyInformationModal={propertyInformationModal}
        handlePropertyInformationModal={handlePropertyInformationModal}
        annualExpenseValues={annualExpenseValues}
        
        />
    );

    const renderRentalEstateGraphModal = () => (
        <RentalEstateGraphModal
            rentalEstateModal={rentalEstateModal}
            handleRentalEstateGraphModal={handleRentalEstateGraphModal}
            graphRecords={graphRecord}
        />
    );

    const renderFooter = () => {
        return (
            <div>
                <div className="grid">
                    {isDesktopOrLaptop && <div className="col-2"></div>}
                    <div
                        className={`${
                            isDesktopOrLaptop
                                ? "col-8  text-align-center"
                                : "col-12 text-align-center"
                        }`}
                    >
                        <div>
                            {/* <Button
								label="Cancel"
								className="p-button-raised p-button p-button-lg"
								// onClick={() => onHide()}
							/> */}
                            {/* <Button
								label="Save"
								className="p-button-raised p-button-warning p-button-lg"
								onClick={handleOwnHouseSave}
							/> */}

                            <div
                                className={` ${
                                    isDesktopOrLaptop ? "mt-2 mb-4" : "mt-5"
                                }`}
                            >
                                {clientId && clientId !== "null" ? (
                                    <Fragment>
                                        <a
                                            href="javascript:;"
                                            onClick={()=>handleReportChangeSave(clientId, true, 'home-ownership')}
                                            className={`${
                                                isDesktopOrLaptop
                                                    ? "mr-5"
                                                    : "mr-4"
                                            }`}
                                        >
                                            Home Ownership Design
                                        </a>
                                     
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <a
                                            href="javascript:;"
                                            onClick={()=>handleReportChangeSave(null, true,'home-ownership')}
                                            className={`${
                                                isDesktopOrLaptop
                                                    ? "mr-5"
                                                    : "mr-3"
                                            }`}
                                        >
                                            Home Ownership Design
                                        </a>
                                      
                                        <div className="mt-4"></div>
                                        {!isDesktopOrLaptop &&
                                        <Link
                                            to="/home-purchase/investment/analysis"
                                            className={`${
                                                isDesktopOrLaptop
                                                    ? "mr-5"
                                                    : "mr-3"
                                            }`}
                                        >
                                            Investment
                                        </Link>
                                        }
                                    </Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const headerTemplate = (options) => {
        const className = `${options.className} p-d-flex justify-content-between`;
        const titleClassName = `${options.titleClassName} pl-1`;
        return (
            <Fragment>
                <div className={className}>
                    <span className={titleClassName}>Ownership Design</span>
                    {/* <div>
                        <label
                            style={{ color: "#333", marginRight: "1rem" }}
                            className={`${options.titleClassName}`}
                        >
                            <a
                                href="javascript:;"
                                onClick={handleRentalEstateGraphModal}
                                style={{ fontWeight: "500" }}
                            >
                                Rental v/s Owned Real Estate
                            </a>
                        </label>
                    </div> */}
                    <div>
                        <label
                            style={{ color: "#333" }}
                            className={`${options.titleClassName}`}
                        >
                            Own&nbsp;-&nbsp;
                        </label>
                        <label
                            style={{ color: "#333" }}
                            className={`${options.titleClassName}`}
                        >
                            {`$${FormatAmount(
                                leftContentValues?.totalMonthlyExpense
                            )}`}
                        </label>
                    </div>
                    {/* <Button
                            style={{ height: "3rem" }}
                            label={`$ ${FormatAmount(
                                leftContentValues?.totalMonthlyExpense
                            )}`}
                            className="p-button-raised p-button-warning p-button-lg ml-4"
                        /> */}
                </div>
            </Fragment>
        );
    };
    const pp = (
        <Fragment>
            <div className="col-12 md:col-12 lg:col-2">
                <label
                    className={`${
                        isDesktopOrLaptop ? "mt-3 margin-pp nowrap" : ""
                    }`}
                >
                    Purchase Price
                </label>
            </div>
            <div className="col-12 md:col-11 lg:col-3">
                <div className={`${isDesktopOrLaptop ? "mb-4 field" : ""}`}>
                    <div className="p-inputgroup">
                       <NumericFormat
                            className="input-field"
                            autoComplete="off"
                            required={true}
                            name="purchasePrice"
                            thousandSeparator=","
                            disabled={false}
                            decimalScale={0}
                            prefix="$ "
                            onBlur={(e) => {
                                if (!e.target.value) {
                                    dispatch(
                                        changeLeftCalculations({
                                            name: "purchasePrice",
                                            value: parseFloat(e.value),
                                        })
                                    );
                                    handleLeftCalculations(
                                        "purchasePrice",
                                        parseFloat(e.value)
                                    );
                                } else {
        
                                    let interestRate =  e.target.value.replace(/[$,]/g, '');
                                    dispatch(
                                        changeLeftCalculations({
                                            name: "purchasePrice",
                                            value: parseFloat(interestRate),
                                        })
                                    );
                                    handleLeftCalculations(
                                        "purchasePrice",
                                        parseFloat(interestRate)
                                    );
                                }
                                
                            }}
                           
                            value={leftContentValues?.purchasePrice}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );

    const interest = (
        <Fragment>
            <div
                className={`col-12 md:col-12 lg:col-2 ${
                    isTablet ? "ml-6" : ""
                }`}
            >
                <label className={`${isDesktopOrLaptop ? "mt-3" : ""}`}>
                    Interest Rate
                </label>
            </div>
            <div
                className={`col-12 md:col-11 lg:col-4 ${
                    isTablet ? "ml-6" : ""
                }`}
            >
                <div className={`${isDesktopOrLaptop ? "field" : ""}`}>
                    <div className="p-inputgroup">
                       {/*} <InputNumber
                            className="vw-inputnumber-with-border"
                            autoComplete="off"
                            required={true}
                            name="interestRate"
                            placeholder="Interest Rate..."
                            disabled={false}
                            formatter={(e) => {
                                alert(e.value)
                                if (e.value !== null) {
                                    alert(e.value)
                                    return `${e.value}%`; // Append the '%' symbol
                                }
                                return "";
                            }}
                            parse={(str) => str.replace('%', '')}
                        mode="decimal"  
                            useGrouping={false}
                            value={
                                mortgageMonthlyExpenses?.firstLoanInterestRate
                            }
                            onBlur={(e) => {
                                if (!e.target.value) {
                                    dispatch(
                                        changeMonthlyMortgageExpenses({
                                            name: "firstLoanInterestRate",
                                            value: FIRST_LOAN_RATE,
                                        })
                                    );
                                } else {
                                    let interestRate = e.target.value.replace(
                                        "%",
                                        ""
                                    );
                                    if (interestRate < 1) {
                                        alert(
                                            "Interest Rate must be greater than 0"
                                        );

                                        // dispatch(
                                        //     changeMonthlyMortgageExpenses({
                                        //         name: "firstLoanInterestRate",
                                        //         value: 0,
                                        //     })
                                        // );
                                        return;
                                    }
                                    if (interestRate > 99.999) {
                                        alert(
                                            "Interest Rate must be lesser than 100"
                                        );
                                        // dispatch(
                                        //     changeMonthlyMortgageExpenses({
                                        //         name: "firstLoanInterestRate",
                                        //         value: 0,
                                        //     })
                                        // );
                                        return;
                                    } else {
                                        dispatch(
                                            changeMonthlyMortgageExpenses({
                                                name: "firstLoanInterestRate",
                                                value: interestRate,
                                            })
                                        );
                                    }
                                }
                            }}
                            onValueChange={(e) => {
                                dispatch(
                                    changeMonthlyMortgageExpenses({
                                        name: "firstLoanInterestRate",
                                        value: e.target.value,
                                    })
                                );
                                // if(!e.target.value) {
                                //     dispatch(
                                //         changeMonthlyMortgageExpenses({
                                //             name: "firstLoanInterestRate",
                                //             value: FIRST_LOAN_RATE,
                                //         })
                                //     );
                                // } else {
                                //     console.log(e.target.value);
                                //     if(e.target.value > 99) {
                                //         alert("Interest Rate must be lesser than 100");
                                //         dispatch(
                                //             changeMonthlyMortgageExpenses({
                                //                 name: "firstLoanInterestRate",
                                //                 value: FIRST_LOAN_RATE,
                                //             })
                                //         );
                                //     } else {
                                //         dispatch(
                                //             changeMonthlyMortgageExpenses({
                                //                 name: "firstLoanInterestRate",
                                //                 value: e.target.value,
                                //             })
                                //         );
                                //     }
                                // }
                                
                            }}
                            // onBlur={(e) => {
                            //     dispatch(
                            //         changeMonthlyMortgageExpenses({
                            //             name: "firstLoanInterestRate",
                            //             value: !!e.target.value ? e.target.value : FIRST_LOAN_RATE,
                            //         })
                            //     );
                            // }}
                            maxFractionDigits={3}
                        /> */}
                        <NumericFormat className="input-field" style={{ width: "150px"}} 
                        value={mortgageMonthlyExpenses?.firstLoanInterestRate} suffix=" %"  
                        allowNegative={false}
                        decimalScale={3}
                         onBlur={(e) => {
                            if (!e.target.value) {
                                dispatch(
                                    changeMonthlyMortgageExpenses({
                                        name: "firstLoanInterestRate",
                                        value: FIRST_LOAN_RATE,
                                    })
                                );
                            } else {
                                let interestRate = e.target.value.replace(
                                    " %",
                                    ""
                                );
                                if (interestRate < 1) {
                                    alert(
                                        "Interest Rate must be greater than 0"
                                    );

                                     dispatch(
                                         changeMonthlyMortgageExpenses({
                                             name: "firstLoanInterestRate",
                                             value: 0,
                                         })
                                     );
                                    return;
                                }
                                if (interestRate > 99.999) {
                                    alert(
                                        "Interest Rate must be lesser than 100"
                                    );
                                     dispatch(
                                         changeMonthlyMortgageExpenses({
                                             name: "firstLoanInterestRate",
                                             value: 99.999,
                                         })
                                     );
                                    return;
                                } else {
                                    dispatch(
                                        changeMonthlyMortgageExpenses({
                                            name: "firstLoanInterestRate",
                                            value: interestRate,
                                        })
                                    );
                                }
                            }
                        }}
                        onValueChange={(values, sourceInfo) => {
                            dispatch(
                                changeMonthlyMortgageExpenses({
                                    name: "firstLoanInterestRate",
                                    value: sourceInfo.event ? sourceInfo.event.target.value : values.value, 
                                })
                            );
                          }}
                         />
                    </div>
                </div>
            </div>
        </Fragment>
    );

    const downpaymentpercent = (
        <Fragment>
            <div className="col-12 md:col-12 lg:col-2">
                <label
                    className={`${
                        isDesktopOrLaptop ? "mt-3 margin-pp nowrap" : ""
                    }`}
                >
                    Down Payment
                </label>
            </div>
            <div className="col-12 md:col-11 lg:col-3">
                <div className={`${isDesktopOrLaptop ? "mb-4 field" : ""}`}>
                    <div className="p-inputgroup">
                        <NumericFormat
                            className="input-field"
                            autoComplete="off"
                            required={true}
                            name="downPaymentPercent"
                            disabled={false}
                            suffix=" %"
                            decimalScale={2}
                            value={leftContentValues?.downPaymentPercent}
                            allowNegative={false}
                            onBlur={(e) => {
                                let current = e.target.value.replace(
                                    " %",
                                    ""
                                );
                                if (!e.target.value || parseFloat(current) === 0) {
                                    dispatch(
                                        changeLeftCalculations({
                                            name: "downPaymentPercent",
                                            value: 3.5,
                                        })
                                    );
                                    handleLeftCalculations(
                                        "downPaymentPercent",
                                        3.5
                                    );
                                } else if (!e.target.value || current > 99.99) {
                                    dispatch(
                                        changeLeftCalculations({
                                            name: "downPaymentPercent",
                                            value: 100
                                        })
                                    );
                                    handleLeftCalculations(
                                        "downPaymentPercent",
                                        100
                                    );
                                    
                                }else {
                                    dispatch(
                                        changeLeftCalculations({
                                            name: "downPaymentPercent",
                                            value: current
                                        })
                                    );
                                    handleLeftCalculations(
                                        "downPaymentPercent",
                                        current
                                    );
                                }
                            }}
                            onValueChange={(values, sourceInfo) => {
                                dispatch(
                                    changeLeftCalculations({
                                        name: "downPaymentPercent",
                                        value: sourceInfo.event ? sourceInfo.event.target.value : values.value, 
                                    })
                                );
                              }}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );

    const downpayment = (
        <Fragment>
            <div className="col-12 md:col-12 lg:col-2 margin-top-dp"></div>

            <div
                className={`col-12 md:col-11 lg:col-4 ${
                    isTablet ? "ml-6" : ""
                }`}
            >
                <div className={`${isDesktopOrLaptop ? "mb-4 field" : ""}`}>
                    <div className="p-inputgroup">
                        <NumericFormat
                            className="input-field"
                            autoComplete="off"
                            required={true}
                            name="downPayment"
                            prefix="$ "
                            disabled={false}
                            thousandSeparator=","
                            decimalScale={0}
                            onBlur={(e) => { 
                                if (!e.target.value) {
                                    dispatch(
                                        changeLeftCalculations({
                                            name: "downPayment",
                                            value: e.value,
                                        })
                                    );
                                    handleLeftCalculations(
                                        "downPayment",
                                        e.value
                                    );
                                } else {
                                    let interestRate =  e.target.value.replace(/[$,]/g, '');
                                    dispatch(
                                        changeLeftCalculations({
                                            name: "downPayment",
                                            value: interestRate
                                        })
                                    );
                                    handleLeftCalculations(
                                        "downPayment",
                                        interestRate
                                    );
                                }
                            }}
                            value={leftContentValues?.downPayment}

                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );

    const monthlyexpense = (
        <Fragment>
            <div className={`col-12 md:col-8 lg:col-2 ml-6 ${
                    isTablet ? "ml-3" : ""
                }`}>
                <label
                    className={`${
                        isDesktopOrLaptop ? "mt-3 nowrap margin-me" : ""
                    } ${
                        isTablet ? "ml-6" : "" 
                    }`}
                >
                    Monthly Expenses
                </label>
            </div>
            <div className={`col-12 md:col-11 lg:col-10 ${
                    isTablet ? "ml-6" : ""
                }`}>
                <div className={`${isDesktopOrLaptop ? "field" : ""}`}>
                    <div
                        className={`${
                            isTablet ? "grid" : "flex-cls"
                        }`}
                    >
                        <div>
                            <InputText
                                style={{ width: '15.5rem' }}
                                autoComplete="off"
                                required={true}
                                name="monthlyExpenses"
                                disabled={true}
                                value={
                                    leftContentValues?.monthlyExpense
                                        ? prefix +
                                          FormatAmount(
                                              leftContentValues?.monthlyExpense
                                          )
                                        : ""
                                }
                            />
                        </div>
                        <div className="col-2 md:col-1 lg:col-1">
                            <a
                                href="javascript:;"
                                className=""
                                onClick={handleMonthlyExpenseModal}
                            >
                                <i className="pi pi-pencil" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );

    const equityValue = (
        <Fragment>
            <div className="col-12 md:col-8 lg:col-2 ml-6">
                <label
                    className={`${
                        isDesktopOrLaptop ? "mt-3 nowrap margin-me" : "" 
                    } ${
                        isTablet ? "ml-6" : "" 
                    }`}
                >
                    Equity
                </label>
            </div>
            <div className="col-12 md:col-11 lg:col-2">
                <div className={`${isDesktopOrLaptop ? "field" : ""}`}>
                    <div
                        className={`${
                            isTablet ? "grid ml-6" : "flex-cls"
                        }`}
                    >
                        <div >
                            <InputText
                                autoComplete="off"
                                required={true}
                                style={{ width: '15.5rem' }}
                                name="equity"
                                disabled={true}
                                value={
                                    leftContentValues?.equity
                                        ? prefix +
                                          FormatAmount(
                                              Number(leftContentValues?.equity).toFixed()
                                          )
                                        : ""
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );

    const annualexpenses = (
        <Fragment>
            <div
                className={`col-12 md:col-8 lg:col-2  ml-6 ${
                    isTablet ? "ml-3" : ""
                }`}
            >
                <label
                    className={`${
                        isDesktopOrLaptop ? "mt-3 nowrap margin-me" : ""
                    } ${
                        isTablet ? "ml-6" : "" 
                    }`}
                >
                    Annual Expenses
                    <br />
                    {isDesktopOrLaptop && (
                        <Fragment>(Prorated Monthly)</Fragment>
                    )}
                </label>
            </div>
            <div
                className={`col-12 md:col-11 lg:col-10 ${
                    isTablet ? "ml-6" : ""
                }`}
            >
                <div className={`${isDesktopOrLaptop ? "field" : ""}`}>
                    <div
                        className={`${
                            isTablet ? "grid" : "flex-cls"
                        }`}
                    >
                        <div>
                            <InputText
                                autoComplete="off"
                                required={true}
                                name="proratedMonthlyExpense"
                                disabled={true}
                                style={{ width: '15.5rem' }}
                                value={
                                    leftContentValues?.proratedMonthlyExpense
                                        ? prefix +
                                          FormatAmount(
                                              leftContentValues?.proratedMonthlyExpense
                                          )
                                        : ""
                                }
                            />
                        </div>

                        <div className="col-2 md:col-1 lg:col-1">
                            <a
                                href="javascript:;"
                                className=""
                                onClick={handleAnnualExpenseModal}
                            >
                                <i
                                    className={`pi pi-pencil ${
                                        isDesktopOrLaptop ? "" : "ml-1 "
                                    }`}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );

    const totalMonthlyExpense = (
        <Fragment>
            <div className="col-12 md:col-8 lg:col-2 ml-6">
                <label
                    className={`${
                        isDesktopOrLaptop ? "mt-3 nowrap margin-me" : ""
                    }`}
                >
                    Total Monthly Expenses
                </label>
            </div>
            <div className="col-12 md:col-8 lg:col-2">
                <div className={`${isDesktopOrLaptop ? "field" : ""}`}>
                    <div >
                        <InputText
                             style={{ width: '15.5rem' }}
                            prefix="$ "
                            autoComplete="off"
                            required={true}
                            name="totalMonthlyExpense"
                            disabled={true}
                            value={
                                leftContentValues?.totalMonthlyExpense
                                    ? prefix +
                                      FormatAmount(
                                          leftContentValues?.totalMonthlyExpense
                                      )
                                    : ""
                            }
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );

    return (
        <Fragment>
            <Panel
                headerTemplate={headerTemplate}
                className={`OwnHouse ${isTablet ? "mt-3" : ""}`}
            >
                <div
                    className={`${
                        isDesktopOrLaptop ? "align-text" : "align-text-left"
                    }`}
                >
                    <div className="grid justify-center ">
                        {isDesktopOrLaptop ? (
                            <Fragment>{pp}</Fragment>
                        ) : (
                            <Fragment>
                                <div
                                    className={`${isTablet ? "w-50 mt-2" : ""}`}
                                >
                                    {pp}
                                </div>
                                <div className={`${isTablet ? "w-50" : ""}`}>
                                    {interest}
                                </div>
                            </Fragment>
                        )}
                        {isDesktopOrLaptop ? (
                            <Fragment>{interest}</Fragment>
                        ) : null}
                    </div>
                    <div className="grid justify-center ">
                        {isDesktopOrLaptop ? (
                            <Fragment>{downpaymentpercent}</Fragment>
                        ) : (
                            <Fragment>
                                <div className={`${isTablet ? "w-50" : ""}`}>
                                    {downpaymentpercent}
                                </div>
                                <div className={`${isTablet ? "w-50" : ""}`}>
                                    {downpayment}
                                </div>
                            </Fragment>
                        )}
                        {isDesktopOrLaptop ? (
                            <Fragment>{downpayment}</Fragment>
                        ) : null}
                    </div>
                    {/* Monthly Expenses */}

                    {isDesktopOrLaptop ? (
                        <Fragment>
                            <div className="grid">{equityValue}</div>
                            <div className="grid">{monthlyexpense}</div>
                            <div className="grid">{annualexpenses}</div>
                        </Fragment>
                    ) : (
                        <Fragment>
                        {isTablet ? (
                            <Fragment>
                                <div className={`${isTablet ? "" : ""}`}>
                                    {equityValue}
                                </div>
                                <div className={`${isTablet ? "" : ""}`}>
                                    {monthlyexpense}
                                </div>
                                <div className={`${isTablet ? "" : ""}`}>
                                    {annualexpenses}
                                </div>
                            </Fragment>
                        ) : (
                            <Fragment>
                            <div className={`${isTablet ? "w-50" : ""}`}>
                                {equityValue}
                            </div>
                            <div className={`${isTablet ? "w-50" : ""}`}>
                                {monthlyexpense}
                            </div>
                            <div className={`${isTablet ? "w-50" : ""}`}>
                                {annualexpenses}
                            </div>
                            </Fragment>
                        )}
                        </Fragment>
                    )}
                    {/* Annual Expenses */}
                    {/* Total Monthly Expenses */}
                    <div className="grid">
                        {isDesktopOrLaptop ? (
                            <Fragment>{totalMonthlyExpense}</Fragment>
                        ) : (
                            <div
                                className={`${
                                    isTablet
                                        ? "w-50 margin-3"
                                        : "totalexpense-width"
                                }`}
                            >
                                {totalMonthlyExpense}
                            </div>
                        )}
                        <div
                            className={`col-2 md:col-6 lg:col-6 ${
                                isTablet ? "text-align-center" : "text-align-center"
                            }`}
                        >
                            <Button
                                label="Save"
                                className={`p-button-raised p-button-warning ${
                                    isDesktopOrLaptop
                                        ? "p-button-lg margin-rt-button"
                                        : "margin-top-button save-width"
                                }`}
                                onClick={handleOwnHouseSave}
                            />
                            <Button
                                label="Add"
                                
                                className={`p-button-raised p-button-warning ${
                                    isDesktopOrLaptop
                                        ? "p-button-lg"
                                        : "margin-top-button save-width"
                                }`}
                                onClick={handlePropertyInformationModal}
                            />
                        </div>
                    </div>
                </div>
                {renderFooter()}
            </Panel>
            {renderMonthlyExpenseModal()}
            {renderAnnualExpenseModal()}
            {renderPropertyInformationModal()}
             {featureModal && renderSubscriptionModal()}
            {/* {renderRentalEstateGraphModal()} */}
            {/* {renderMortgageStructureModal()} */}
        </Fragment>
    );
};

export default OwnHouse;
